import { ComponentCategory } from "@/types/types";

export const accessoriesComponents: ComponentCategory = {
  id: "accessories",
  name: "Accessories",
  description: "Enhance your build with optional accessories.",
  required: false,
  options: [
    {
      id: "vertical-gpu-mount-black",
      name: "Vertical GPU Mount - Black",
      price: 59.99,
      brand: "Phanteks",
      imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images/616p52v-N1L._AC_SL1500_.webp",
      specs: {
        description: "Showcase your GPU with this vertical mount.",
        color: "Black"
      },
      incompatibleCases: ["case-3"]
    },
    {
      id: "lian-li-strimer-plus-v2-24pin",
      name: "Lian Li Strimer Plus V2 24-Pin",
      price: 69.99,
      brand: "Lian Li",
      imageUrl: "/images/accessories/strimer_24pin.png",
      specs: {
        description: "Addressable RGB 24-pin motherboard cable for a vibrant look.",
        type: "24-Pin ATX",
        rgb: "Addressable"
      }
    },
    {
      id: "lian-li-strimer-plus-v2-8pin",
      name: "Lian Li Strimer Plus V2 Dual 8-Pin",
      price: 49.99,
      brand: "Lian Li",
      imageUrl: "/images/accessories/strimer_8pin.png",
      specs: {
        description: "Addressable RGB dual 8-pin GPU cable to complete your setup.",
        type: "Dual 8-Pin PCIe",
        rgb: "Addressable"
      }
    },
    {
      id: "extended-warranty",
      name: "Extended Warranty",
      price: 100,
      brand: "Battleforge",
      imageUrl: "",
      specs: {
        description: "Extend your warranty for an additional year."
      }
    },
    {
      id: "faster-shipping",
      name: "Faster Shipping - 1 Week",
      price: 100,
      brand: "Battleforge",
      imageUrl: "",
      specs: {
        description: "Get your build faster with priority shipping."
      }
    }
  ]
};
